module.exports = __webpack_public_path__ + "media/src/images/partners/rwth-5d030acf3c04de19e9001ca7ed61c661.jpg";